import { PaperPlaneTilt } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Input as BaseInput } from 'core/components';
import { enterPress } from 'core/utils';

interface IProps {
  onSubmit: (value: string) => void;
}

export const Input = ({ onSubmit }: IProps) => {
  const [value, setValue] = useState('');

  const { t } = useTranslation();

  const handleChange = (value: string) => {
    setValue(value);
  };

  const handleSubmit = () => {
    onSubmit(value);
    setValue('');
  };

  return (
    <BaseInput
      value={value}
      placeholder={t('placeholderAskAI')}
      endDecorator={<Button icon={<PaperPlaneTilt />} onClick={handleSubmit} />}
      onChange={(e) => handleChange(e.target.value)}
      onKeyDown={(e) => {
        enterPress(e, handleSubmit);
      }}
    />
  );
};
